import { Customer } from '../customer';
import { Partner } from '../partner';
import { PageRequest } from '../page-request.data';
import { Sort } from '../sort.data';
import { CustomerLightData } from '../customer-light.data';

export interface NavbarState {
  customers: CustomerLightData[];
  partners: Partner[];
  customerPageRequest: PageRequest;
  partnerPageRequest: PageRequest;
  loading: boolean;
  completed: boolean;
  partnerLoading: boolean;
  partnerCompleted: boolean;
}

export const initialNavbarState: NavbarState = {
  customers: [],
  partners: [],
  customerPageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  partnerPageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  loading: false,
  completed: false,
  partnerLoading: false,
  partnerCompleted: false,
};
